"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TWILIO_TEXT_STATUS = exports.TWILIO_VOICE_CALL_STATUS = exports.EmailType = exports.VendorInteractionState = exports.CustomerActionType = exports.VendorActionType = exports.SendGridEventType = void 0;
var SendGridEventType;
(function (SendGridEventType) {
    SendGridEventType["INIT"] = "init";
    SendGridEventType["PROCESSED"] = "processed";
    SendGridEventType["DEFERRED"] = "deferred";
    SendGridEventType["DROPPED"] = "dropped";
    SendGridEventType["BOUNCE"] = "bounce";
    SendGridEventType["BLOCKED"] = "blocked";
    SendGridEventType["DELIVERED"] = "delivered";
    SendGridEventType["CLICK"] = "click";
    SendGridEventType["OPEN"] = "open";
    SendGridEventType["UNSUBSCRIBE"] = "unsubscribe";
    SendGridEventType["GROUPUNSUBSCRIBE"] = "group_unsubscribe";
    SendGridEventType["GROUPRESUBSCRIBE"] = "group_resubscribe";
    SendGridEventType["SPAMREPORT"] = "spamreport";
})(SendGridEventType = exports.SendGridEventType || (exports.SendGridEventType = {}));
var VendorActionType;
(function (VendorActionType) {
    VendorActionType["VIEW"] = "view";
    VendorActionType["BID"] = "bid";
    VendorActionType["DECLINED"] = "declined";
    VendorActionType["COMMENT"] = "comment";
    VendorActionType["AWARDED"] = "awarded";
    VendorActionType["INTERESTED"] = "interested";
})(VendorActionType = exports.VendorActionType || (exports.VendorActionType = {}));
var CustomerActionType;
(function (CustomerActionType) {
    CustomerActionType["REVOKEAWARD"] = "revoke_award";
})(CustomerActionType = exports.CustomerActionType || (exports.CustomerActionType = {}));
// processed, not delivered, delivered, read, responded, awarded
var VendorInteractionState;
(function (VendorInteractionState) {
    VendorInteractionState["PROCESSED"] = "processed";
    VendorInteractionState["NOTDELIVERED"] = "not_delivered";
    VendorInteractionState["DELIVERED"] = "delivered";
    VendorInteractionState["READ"] = "read";
    VendorInteractionState["VIEW"] = "view";
    VendorInteractionState["RESPONDED"] = "responded";
    VendorInteractionState["AWARDED"] = "awarded";
    VendorInteractionState["INTERESTED"] = "interested";
    VendorInteractionState["NO_RESPONSE"] = "no_response";
    VendorInteractionState["DECLINED"] = "declined";
})(VendorInteractionState = exports.VendorInteractionState || (exports.VendorInteractionState = {}));
var EmailType;
(function (EmailType) {
    EmailType["QuoteRequestPhone"] = "QuoteRequestPhone";
    EmailType["QuoteRequestMail"] = "QuoteRequestMail";
    EmailType["QuoteRequestText"] = "QuoteRequestText";
    EmailType["VendorReceiptMail"] = "VendorReceiptMail";
    EmailType["VendorReceiptText"] = "VendorReceiptText";
    EmailType["AwardMail"] = "AwardMail";
    EmailType["AwardText"] = "AwardText";
    EmailType["RevokeAwardMail"] = "RevokeAwardMail";
    EmailType["RevokeAwardText"] = "RevokeAwardText";
    EmailType["QuoteCancelMail"] = "QuoteCancelMail";
    EmailType["QuoteCancelText"] = "QuoteCancelText";
    EmailType["BidNotificationMail"] = "BidNotificationMail";
    EmailType["VendorReceiptMailOnBehalf"] = "VendorReceiptMailOnBehalf";
    EmailType["VendorReceiptTextOnBehalf"] = "VendorReceiptTextOnBehalf";
    EmailType["QuoteRequestReminderMail"] = "QuoteRequestReminderMail";
    EmailType["QuoteRequestReminderPhone"] = "QuoteRequestReminderPhone";
    EmailType["QuoteRequestReminderText"] = "QuoteRequestReminderText";
    EmailType["SMStoEmailMessageBridge"] = "SMStoEmailMessageBridge";
    EmailType["MailMessage"] = "MailMessage";
    EmailType["MailMessageFromVendor"] = "MailMessageFromVendor";
    EmailType["SmsMessage"] = "SmsMessage";
    EmailType["SmsMessageFromVendor"] = "SmsMessageFromVendor";
})(EmailType = exports.EmailType || (exports.EmailType = {}));
var TWILIO_VOICE_CALL_STATUS;
(function (TWILIO_VOICE_CALL_STATUS) {
    TWILIO_VOICE_CALL_STATUS["QUEUED"] = "queued";
    TWILIO_VOICE_CALL_STATUS["INITIATED"] = "initiated";
    TWILIO_VOICE_CALL_STATUS["RINGING"] = "ringing";
    TWILIO_VOICE_CALL_STATUS["IN_PROGRESS"] = "in-progress";
    TWILIO_VOICE_CALL_STATUS["COMPLETED"] = "completed";
    TWILIO_VOICE_CALL_STATUS["BUSY"] = "busy";
    TWILIO_VOICE_CALL_STATUS["NO_ANSWER"] = "no-answer";
    TWILIO_VOICE_CALL_STATUS["CANCELED"] = "canceled";
    TWILIO_VOICE_CALL_STATUS["FAILED"] = "failed";
})(TWILIO_VOICE_CALL_STATUS = exports.TWILIO_VOICE_CALL_STATUS || (exports.TWILIO_VOICE_CALL_STATUS = {}));
var TWILIO_TEXT_STATUS;
(function (TWILIO_TEXT_STATUS) {
    TWILIO_TEXT_STATUS["SENT"] = "sent";
    TWILIO_TEXT_STATUS["DELIVERED"] = "delivered";
    TWILIO_TEXT_STATUS["UNDELIVERED"] = "undelivered";
    TWILIO_TEXT_STATUS["FAILED"] = "failed";
    TWILIO_TEXT_STATUS["QUEUED"] = "queued";
})(TWILIO_TEXT_STATUS = exports.TWILIO_TEXT_STATUS || (exports.TWILIO_TEXT_STATUS = {}));
